/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { buttonsList } from './document.buttons'
import { PurchaseDocument } from 'src/core/models'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import styles from './PurchaseDocumentButtonsContent.module.scss'
import ValidatePurchaseDocumentButtons from './ValidatePurchaseDocumentButtons/ValidatePurchaseDocumentButtons'
import {
  resetValidateCarbonForwardFile,
  resetValidateCancelationState,
  validateCancellationDocument,
  resetValidateTaxReliefState,
  resetValidateReceiptState,
  validateCarbonForwardFile,
  validateTaxReliefDocument,
  purchaseDocumentsSelector,
  validateReceiptDocument,
  getPurchaseDocuments,
} from 'src/features'

const PurchaseDocumentButtonsContent: React.FC<{ document: PurchaseDocument }> = ({ document }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const documentState = useAppSelector(purchaseDocumentsSelector)
  const {
    validateCancellation: { success: successCancellation, currentDocumentId: documentCancellationId },
    validateReceipt: { success: successReceipt, currentDocumentId: documentReceiptId },
    validateTaxRelief: { success: successTaxRelief, currentDocumentId: documentTaxId },
    validateCarbonForwardFile: { success: successCarbonForward, currentDocumentId: documentForwardId },
    filterText
  } = documentState

  const handleValidateCancelation = () => {
    dispatch(validateCancellationDocument(document.id))
  }

  const handleValidateRecept = () => {
    dispatch(validateReceiptDocument(document.id))
  }

  const handleValidateTax = () => {
    dispatch(validateTaxReliefDocument(document.id))
  }

  const handleValidateForwardFile = () => {
    dispatch(validateCarbonForwardFile(document.id))
  }

  const buttons = buttonsList(
    t, document, handleValidateCancelation,
    handleValidateRecept, handleValidateTax,
    handleValidateForwardFile, documentState
  )

  const isDividerVisible = (idx: number): boolean => {
    const listLength = buttons.filter(b => b.isVisible).length
    if (listLength === 1) return false
    return idx !== listLength
  }

  useEffect(() => {
    if (successCancellation && documentCancellationId === document.id) {
      showNotification('success', t('Document.Validated'))
      dispatch(resetValidateCancelationState())
      dispatch(getPurchaseDocuments(filterText))
    }
  }, [successCancellation])

  useEffect(() => {
    if (successReceipt && documentReceiptId === document.id) {
      showNotification('success', t('Document.Validated'))
      dispatch(resetValidateReceiptState())
      dispatch(getPurchaseDocuments(filterText))
    }
  }, [successReceipt])

  useEffect(() => {
    if (successTaxRelief && documentTaxId === document.id) {
      showNotification('success', t('Document.Validated'))
      dispatch(resetValidateTaxReliefState())
      dispatch(getPurchaseDocuments(filterText))
    }
  }, [successTaxRelief])

  useEffect(() => {
    if (successCarbonForward && documentForwardId === document.id) {
      showNotification('success', t('Document.Validated'))
      dispatch(resetValidateCarbonForwardFile())
      dispatch(getPurchaseDocuments(filterText))
    }
  }, [successCarbonForward])

  return (
    <div className={`${styles.content} collapse-animation`}>
      {buttons.map((button, idx) => <React.Fragment key={idx}>
        {button.isVisible && <>
          <ValidatePurchaseDocumentButtons {...button} />
          {isDividerVisible(idx) && <div className={styles.divider} />}
        </>}
      </React.Fragment>)}
    </div>
  )

}

export default PurchaseDocumentButtonsContent
